module.exports = __webpack_public_path__ + "assets/img/head1-en.14570d13.png";